import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class FrontDeskNoShowReport extends AbstractReport {
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'room_type',
    'reservation_id',
    'guest_id',
    'source_name',
    'source_reservation_id',
)(FrontDeskNoShowReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/front-desk/no-show-report.model.js